<template>
  <div class="gallery">
    <div class="page__wr">
      <div class="gallery__wr">
        <div class="gallery__title-wr title-oblique-line-anima">
          <h1 class="gallery__title title-anima">{{ h1 }}</h1>
        </div>
        <div class="gallery__content">
          <div class="gallery__slider js-gallery-slider">
            <div class="swiper-container" ref="swiperContainer">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in items">
                  <router-link class="gallery__slider-item" :to="item.link">
                    <div class="gallery__slider-img gallery__slider-img--big" v-if="item.img"
                         :style="`background-image: url(${item.img})`"></div>
                    <div class="gallery__slider-date" v-if="item.date" v-html="item.date"></div>
                    <div class="gallery__slider-title" v-if="item.title" v-html="item.title"></div>
                    <div class="gallery__slider-type" v-if="item.type" v-html="item.type"></div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="gallery__slider-pagination-wr">
              <div class="swiper-button-prev">
                <SvgIcon class="gallery__slider-ico" name="arrow-left" width="7" height="11"></SvgIcon>
              </div>
              <div class="swiper-pagination" v-if="countOfSlideInPage &gt; 2"></div>
              <div class="swiper-button-next">
                <SvgIcon class="gallery__slider-ico" name="arrow-left" width="7" height="11"></SvgIcon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gallery__bottom-nav">
        <div class="page__wr">
          <BottomNav :links="links" :btn="btn"></BottomNav>
        </div>
        <Samedia></Samedia>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

// @ is an alias to /src


import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'Gallery',

  mixins: [AjaxHelpersVue, PopupHelpersVue, determineWindowSize],

  components: {
    BottomNav,
    SvgIcon,
    Samedia
  },

  data() {
    return {
      countOfSlideInPage: 0,
      links: {
        prev: {
          href: "/akcii",
          txt: "Акции"
        },
        next: {
          href: "/kontakty",
          txt: "Контакты"
        }
      },
      btn: false,
      tmpl: '',
      items: null
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadGalleryPage', url => {
      this.request(url);
    });
  },

  mounted() {
  },

  methods: {
    request(url) {
      this.req('GalleryPage:getGalleryPage', {url}, res => {
        if (this.checkProperty(res.content.items)) {
          this.items = res.content.items;
          //this.generateSlidesTmpl(res.content.items);
        }
        this.determineWindowSize();
        this.$nextTick(() => {
          this.initSlider();
        });
        EventBus.$emit('pageDone');
      }, 'gallery');
    },

    generateSlidesTmpl(items) {
      let classes = [
        'gallery__slider-img--big',
        'gallery__slider-img--small-1',
        'gallery__slider-img--small-2',
        'gallery__slider-img--medium-1',
        'gallery__slider-img--medium-2'
      ];

      let classesLength = classes.length;

      this.tmpl = '';

      items.forEach((el, i) => {
        let placeInArray = i % classesLength;

        // для big - одна картинка
        if (placeInArray === 0)
          this.tmpl += `<div class="swiper-slide"><div class="gallery__slider-item">`;

        // для остальных картинок
        if (placeInArray >= 1 && placeInArray % 2) {
          this.tmpl += `<div class="swiper-slide"><div class="gallery__slider-item">`;
        }

        this.tmpl += `
            <div data-src="${el.imgPreview}" data-fancybox="gallery-slider" class="gallery__slider-img ${classes[placeInArray]}" style="background-image: url('${el.imgFull}');"></div>
        `;

        // для big - одна картинка
        if (placeInArray === 0) {
          this.tmpl += `</div></div>`;
        }

        // для остальных картинок
        if (placeInArray >= 2 && !(placeInArray % 2)) {
          this.tmpl += `</div></div>`;
        }

        // для последней картики, если она одна в .gallery__slider-item
        if ((placeInArray % 2) && i === (items.length - 1)) {
          this.tmpl += `</div></div>`;
        }
      });

      this.$nextTick(() => {
        this.initSlider();
      });
    },

    initSlider() {
      let $slider = $('.js-gallery-slider');
      let $sliderNextBtn = $slider.find('.swiper-button-next');
      let $sliderPrevBtn = $slider.find('.swiper-button-prev');
      let $sliderPagination = $slider.find('.swiper-pagination');

      if ($slider.find('.swiper-slide-active').length) return;

      let sliderParams = {
        init: false,
        //autoplay: {
        //  delay: 5000
        //},
        slidesPerView: this.countOfSlideInPage,
        spaceBetween: 10,
        navigation: {
          nextEl: $sliderNextBtn,
          prevEl: $sliderPrevBtn
        },
        pagination: {
          el: $sliderPagination,
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 10,
        },
        breakpoints: {
          1400: {
            pagination: {
              dynamicMainBullets: 4,
            }
          }
        },
        //loop: true, // в цикле не работают события вью из-за клонирования слайдов без событий
        simulateTouch: true,
        observer: true, // если слайдер изначально скрыт
        observeParents: true // если слайдер изначально скрыт
      };

      if ($slider.find('.gallery__slider-item').length <= 3) {
        $.extend(sliderParams, {
          loop: false,
          virtualTranslate: true
        });

        $sliderNextBtn.hide();
        $sliderPrevBtn.hide();
        $sliderPagination.hide();
      }

      if ($slider.length) {
        let swiper = new Swiper(this.$refs.swiperContainer, sliderParams);
        swiper.init();
      }
    },
  }
}
</script>
